export default "__VITE_ASSET__BS6UIM3U__"